<div class="carousel-inner">
  <div class="carousel-item active">
    <img class="blog-img" [src]="getImageUrl(blogDetail.blogImagepath)" />
    <div class="carousel-caption d-md-block">
      <div class="blog-details">
        <h5>
          {{ blogDetail.title }}
        </h5>
        <!-- <h2>{{userDetail.full_name}}</h2>
      <h3>{{userDetail.position}}</h3> -->
        <!-- Need to add Router Link -->
        <div>
          <a
            [routerLink]="viewBloglink(blogDetail._id)"
            class="btn btn-viewblog"
            >View Blog</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
